import React from "react";
import { Typography } from "@mui/material";

interface Props {
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
}

const SettingWorkerStatus: React.FC<Props> = ({
  startDate,
  endDate,
  startTime,
  endTime,
}) => {
  // 現在日時
  const currentDate = new Date();
  const startDateTime = new Date(`${startDate}T${startTime}`);
  const endDateTime = new Date(`${endDate}T${endTime}`);

  // 条件によるテキストの決定
  const displayText =
    endDateTime > currentDate && startDateTime <= currentDate
      ? "使用中"
      : startDateTime >= currentDate
        ? "使用予定者"
        : "過去使用者";

  return <Typography>{displayText}</Typography>;
};

export default SettingWorkerStatus;
